<template>
  <tr class="font-bold montserrat text-sm text-gray-700">
    <div class="h-8"></div>
    <th v-for="platform of platforms" :key="platform" class="pr-3 w-24 h-14">
      {{ platform }}
    </th>
  </tr>
</template>

<script>
export default {
  name: 'PlatformsTableHeader',
  props: {
    platforms: Array,
  },
}
</script>
